<app-back-header [filterOption]="this.activeTab === 'global' ? FilterOption.enabled : FilterOption.disabled " (action)="SetEvent($event, DashboardRoutesType.Dashboard)" title="{{ 'MEDIFINDER.TITLE' | translate }}" [ngStyle]="{'transform': 'translateX(' + leftSwipePosition + 'px)' }"></app-back-header>
<div class="container" >


  <div class="content" [ngStyle]="{'transform': 'translateX(' + leftSwipePosition + 'px)' }">
    @if (!userHasPharmacies) {
      <div class="spacer spacer-2"></div>
    }
    <div class="button-wrapper">
      @if (userHasPharmacies) {
        <app-button label="MEDIFINDER.NEW_SEARCH.BUTTON" [fullWidth]="true" (click)="triggerNewSearchModal()"></app-button>
      }
      <app-icon-button class="icon-button" src="icons/32/info.svg" (click)="mediFinderInfoModalOpen = true"></app-icon-button>
    </div>
    <div class="spacer spacer-2"></div>


    @if (showPersonalTab) {
      <div class="row" >
        <div class="col-xsmall-12">
          <div class="info-overview__tab-wrapper">
            <app-tabs (action)="SetEvent($event)"  [items]="[{label: 'Gesucht wird', active: this.activeTab === 'global', value: 'global',weight: 0 },{label: 'Meine Suchen', active: this.activeTab === 'personal', value: 'personal',weight: 10 }]"></app-tabs>
            <div class="spacer"></div>
          </div>
        </div>
      </div>
    }
    <div class="row" appSwipe (leftSwipePosition)="leftSwipePosition = $event" [ngStyle]="{'left.px': leftSwipePosition }" (leftSwipe)="BackToDashboard()">
      <div class="col-xsmall-12" >
        <div class="spacer-and-half"></div>
        @if ((search$ | async); as globalSearches) {
          <div class="info-overview__container" [@listAnimation]="globalSearches.length" [@.disabled]="globalSearches.length > 16">
            @if (globalSearches.length == 0) {
              <p class="center info-overview__no-results">{{ 'MEDIFINDER.SEARCH_RESULT.NO_RESULT' | translate}}</p>
            }
            <ngx-pull-to-refresh spinnerColor="#ff0000"
              [spinnerSize]="50"
              [distanceForRefresh]="100"
              [isEnable]="enablePullToRefresh"
              [targetElement]="targetElement"
              (refresh)="refresh($event, 'refresh')"
              style="display:block;height:100%;">
              @for (search of globalSearches; track track($index, search)) {
                <div>
                  <app-medifinder-search-card
                    class="box"
                    [infoDate]="search.attributes.created"
                    [title]="search.attributes.package_name"
                    [pharmacyId]="search.relationships.owner_pharmacy.data.id"
                    [own]="search.attributes.own"
                    (action)="SetEvent($event, DashboardRoutesType.MediFinderDetail, search.id)"
                    id="{{search.id}}"
                    >
                  </app-medifinder-search-card>
                </div>
              }
            </ngx-pull-to-refresh>
          </div>
        } @else {
          <app-loading></app-loading>
        }
        <app-load-more-button [viewHelper]="view"></app-load-more-button>
        <div class="spacer-4"></div>
      </div>
    </div>
  </div>



</div>


<app-medifinder-filter-modal [open]="filterModalIsOpen" (openChange)="filterModalIsOpen = $event" (output)="SetAction($event)"></app-medifinder-filter-modal>

<app-new-medifinder-search-modal [(open)]="newSearchModal" (reloadView)="changeView(true)"></app-new-medifinder-search-modal>

<app-medifinder-info-modal [(open)]="mediFinderInfoModalOpen"></app-medifinder-info-modal>
